export default {
  incidents: {
    filterTitle: ' Filter by status',
    label: 'Incidents',
    actions: {
      report: 'Report',
    },
    status: {
      reported: 'Reported',
      resolved: 'Resolved',
      all: 'All',
    },
    reports: {
      label: 'Reported Incidents',
      new: 'Report Incident',
      view: 'View Incident',
      resolve: 'Resolve Incident',
      dateOfIncident: 'Date of Incident',
      department: 'Department',
      download: 'Download',
      category: 'Category',
      categoryItem: 'Category Item',
      description: 'Description of Incident',
      patient: 'Patient',
      code: 'Code',
      reportedBy: 'Reported By',
      reportedOn: 'Reported On',
      resolvedOn: 'Resolved On',
      status: 'Status',
      error: {
        dateRequired: 'Date is required.',
        dateMustBeInThePast: 'Date must be in the past.',
        departmentRequired: 'Department is required.',
        categoryRequired: 'Category is required',
        categoryItemRequired: 'Category Item is required',
        descriptionRequired: 'Description is required',
      },
    },
    visualize: {
      label: 'Visualize',
      view: 'Visualize Incidents',
    },
  },
}
